export const generateUrlName = (name: string) =>
  name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[!?@#$^*`%&()\\/|'"’“~<>{}[\]:;,.+=]/g, '')
    .replace(/™|®|©/g, '');
